__turbopack_context__.v({
  "close": "ModalContent-module-scss-module__O-TxmW__close",
  "container": "ModalContent-module-scss-module__O-TxmW__container",
  "content": "ModalContent-module-scss-module__O-TxmW__content",
  "inner": "ModalContent-module-scss-module__O-TxmW__inner",
  "line": "ModalContent-module-scss-module__O-TxmW__line",
  "name": "ModalContent-module-scss-module__O-TxmW__name",
  "title": "ModalContent-module-scss-module__O-TxmW__title",
});
